import React from 'react';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  agentName: string;
  isDeleting?: boolean;
}

/* 旧 styled-components 定義をクラス文字列定数として保持。
 * font-size は line-height が別指定なのでどちらも arbitrary value で保持する。 */
const MODAL_BACKDROP =
  'fixed top-0 left-0 w-full h-full bg-black/50 flex justify-center items-center z-[1000]';

const MODAL_CONTENT =
  'w-[90%] max-w-[450px] bg-white rounded-tasky-md shadow-[0_10px_40px_rgba(0,0,0,0.3)] overflow-hidden';

const MODAL_HEADER = 'p-6 bg-red-50 border-b border-b-red-200'; /* #FEF2F2 / #FECACA */

const MODAL_TITLE =
  'text-[1.125rem] font-semibold text-red-800 m-0 flex items-center gap-2'; /* #991B1B */

const WARNING_ICON = 'text-[1.25rem]';

const MODAL_BODY = 'p-6';

const MESSAGE = 'text-[0.875rem] text-gray-700 leading-[1.6] m-0 mb-4'; /* #374151 */

const AGENT_NAME = 'text-gray-800 font-semibold'; /* #1F2937 */

const WARNING_MESSAGE =
  'px-4 py-3 bg-red-50 border-l-[3px] border-l-red-500 rounded text-[0.75rem] ' +
  'text-red-900 leading-[1.4]'; /* #FEF2F2 / #EF4444 / #7F1D1D */

const MODAL_FOOTER = 'px-6 py-4 border-t border-t-gray-200 flex justify-end gap-3'; /* #E5E7EB */

const BUTTON_BASE =
  'px-5 py-2.5 rounded-tasky-xs text-[0.875rem] font-medium cursor-pointer transition-all duration-200';
const BUTTON_DANGER =
  'border-0 bg-red-600 text-white hover:bg-red-700 disabled:bg-red-300 disabled:cursor-not-allowed'; /* #DC2626 / #B91C1C / #FCA5A5 */
const BUTTON_DEFAULT =
  'bg-white text-gray-700 border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed'; /* #D1D5DB / #F9FAFB */

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  agentName,
  isDeleting = false,
}) => {
  if (!isOpen) {
    return null;
  }

  const handleConfirm = () => {
    onConfirm();
  };

  return (
    <div className={MODAL_BACKDROP} onClick={onClose}>
      <div className={MODAL_CONTENT} onClick={(e) => e.stopPropagation()}>
        <div className={MODAL_HEADER}>
          <h2 className={MODAL_TITLE}>
            <span className={WARNING_ICON}>⚠️</span>
            エージェントを削除
          </h2>
        </div>

        <div className={MODAL_BODY}>
          <p className={MESSAGE}>
            <strong className={AGENT_NAME}>{agentName}</strong> を削除してもよろしいですか？
          </p>

          <div className={WARNING_MESSAGE}>
            この操作は取り消せません。削除されたエージェントは復元できませんので、ご注意ください。
          </div>
        </div>

        <div className={MODAL_FOOTER}>
          <button className={`${BUTTON_BASE} ${BUTTON_DEFAULT}`} onClick={onClose} disabled={isDeleting}>
            キャンセル
          </button>
          <button className={`${BUTTON_BASE} ${BUTTON_DANGER}`} onClick={handleConfirm} disabled={isDeleting}>
            {isDeleting ? '削除中...' : '削除する'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
